import { FormattedMessage } from 'react-intl';

import { Lineup } from '@sorare/core/src/atoms/icons/Lineup';
import { BrandXXS } from '@sorare/core/src/atoms/typography/index.tsx';

type Props = {
  count: number;
};

export const PrepareLineupTooltipContent = ({ count }: Props) => (
  <div className="flex items-center gap-1">
    <Lineup size={2} color="var(--c-onBase-secondary)" />
    <BrandXXS color="var(--c-onBase-secondary)" className="text-nowrap">
      <FormattedMessage
        defaultMessage="Pre-set lineups{count, plural, =0 {} other { (#)}}"
        values={{ count }}
      />
    </BrandXXS>
  </div>
);
